module.exports = __webpack_public_path__ + "static/media/comment-lines.fbb50ffb.svg";